import React, { forwardRef, HTMLProps, ReactNode } from 'react'
import { useMergeRefs } from '@floating-ui/react'
import { usePopoverContext } from './popover'

interface PopoverTriggerProps {
  children: ReactNode
}

export const PopoverTrigger = forwardRef<HTMLElement, HTMLProps<HTMLElement> & PopoverTriggerProps>(
  ({ children, ...props }, propRef) => {
    const context = usePopoverContext()
    const childrenRef = (children as any).ref
    const ref = useMergeRefs([context.refs.setReference, propRef, childrenRef])

    if (React.isValidElement(children))
      return React.cloneElement(
        children,
        context.getReferenceProps({
          ref,
          ...props,
          ...children.props,
          'data-state': context.open ? 'open' : 'closed',
        })
      )

    return null
  }
)

PopoverTrigger.displayName = 'PopoverTrigger'
